import store from '@/store/store.js'
import devMode from '@/devMode.js'
import logScope from 'log-scope'
const log = logScope('analytics')

const isDevMode = devMode.isDevMode
const analytics = {}

analytics.init = () => {
  const gaIsDisabled = localStorage.getItem('gaIsDisabled') === 'true'
  analytics.disable(gaIsDisabled)
}

analytics.isDisabled = () => {
  if (isDevMode || window.k$.isLoggedIn) {
    log.danger('Is dev mode or admin, do not log')
    return true
  }

  if (!window.gtag) {
    log.danger('No gtag')
    return true
  }

  return false
}

analytics.pageView = page => {
  if (analytics.isDisabled()) {
    return
  }

  window.gtag('event', 'navigation', {
    'event_category': 'pageview',
    'event_label': page
  })
}

analytics.signup = () => {
  if (analytics.isDisabled()) {
    return
  }

  window.gtag('event', 'sign_up', { 'method': 'email address' })

  if (window.fbq) {
    window.fbq('track', 'CompleteRegistration')
  }
}

analytics.addToCart = () => {
  const value = store.getters.totalAmount
  const currency = 'SEK'
  const items = 'HeadQ'

  window.gtag('event', 'add_to_cart', { value, currency, items })
  log.debug('Add to cart')

  if (window.fbq) {
    window.fbq('track', 'AddToCart')
  }
}

analytics.purchase = () => {
  if (analytics.isDisabled()) {
    return
  }

  const value = store.getters.totalAmount
  const currency = 'SEK'
  const items = 'HeadQ'
  const coupon = store.getters.couponCode

  window.gtag('event', 'purchase', { value, currency, items, coupon })
  log.debug('Purchase', { value, currency })

  if (window.fbq) {
    window.fbq('track', 'Purchase')
  }
}

analytics.disable = (boo = true) => {
  if (boo !== true) {
    return
  }

  window['ga-disable-UA-132415937-1'] = boo
  localStorage.setItem('gaIsDisabled', 'true')
  log.danger('Disabling analytics tracking.')
}

analytics.log = (type, ...options) => {
  if (analytics.isDisabled()) {
    return
  }

  analytics[type](...options)
}

export default analytics
